var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 599.999999",
    height: 800,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "91399d70da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 386.132812 386.132812 L 599.882812 386.132812 L 599.882812 599.882812 L 386.132812 599.882812 Z M 386.132812 386.132812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d6ac7e364"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.621094 22.621094 L 577.621094 22.621094 L 577.621094 577.621094 L 22.621094 577.621094 Z M 22.621094 22.621094 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91399d70da)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#db2762",
    d: "M 493.074219 386.132812 C 503.488281 474.195312 511.9375 482.644531 600 493.058594 C 511.9375 503.488281 503.488281 511.9375 493.074219 600 C 482.644531 511.9375 474.195312 503.488281 386.132812 493.058594 C 474.195312 482.644531 482.644531 474.195312 493.074219 386.132812 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d6ac7e364)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1de7c",
    d: "M 300.015625 22.621094 C 327.027344 251.050781 348.945312 272.96875 577.375 299.980469 C 348.945312 327.027344 327.027344 348.945312 300.015625 577.375 C 272.96875 348.945312 251.050781 327.027344 22.621094 299.980469 C 251.050781 272.96875 272.96875 251.050781 300.015625 22.621094 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star_2.09a84f6adb5ed30a056aea7c39ba9714.svg";
export { ForwardRef as ReactComponent };